import { ScrollReveal } from '../scroll-reveal'

/* FAQ, a quiet, border-divided list of the questions a practice asks first.
 * Exported because `/en` feeds it into FAQPage JSON-LD. */

export const EN_FAQS = [
  {
    a: 'Planno is the professional tool for architecture, interior design, and engineering practices running several projects at once, currently spread across email, messaging, cloud storage, and spreadsheets. It works for a sole practitioner through to a team of fifteen.',
    q: 'Who is Planno for?',
  },
  {
    a: 'No. Start with the tasks on a single project and bring the rest over at your own pace. Gmail, Outlook, Google Drive, and your calendar keep working, connected to Planno.',
    q: 'Do I have to move everything at once?',
  },
  {
    a: 'Yes — that is the point. Site visits, punch lists, photos, field items, and the daily log live in the same place as the drawings, the tasks, and the project’s finances.',
    q: 'Does Planno cover construction administration, not just design?',
  },
  {
    a: 'You enter the practice’s fixed costs, the team’s billable hours, taxes, and the margin you want to hold. Planno calculates the cost per billable hour in real time and uses it as the basis for every fee proposal. A cost changes? Pending proposals change with it.',
    q: 'How does billable-rate pricing work?',
  },
  {
    a: 'Yes, through the official WhatsApp Business API. You talk to the Planno assistant from your own WhatsApp: ask what came out of a site visit, how the sprint is tracking, or what moved on a project, and create tasks, contacts, and other records right there in the conversation. What you ask for lands in the practice against the right project and owner.',
    q: 'Is the WhatsApp integration official?',
  },
  {
    a: 'Summarize progress on any project, draft specs, sign-off letters, emails, and proposals from the brief, review contracts against your practice’s legal checklist, and generate realistic renderings from SketchUp screenshots.',
    q: 'What can Planno AI do?',
  },
  {
    a: 'Contracts, drawings, and client details are treated as sensitive data: encrypted in transit and at rest, a full audit log, and a complete export whenever you want to leave. Planno is built and operated in Brazil under the LGPD, Brazil’s data-protection law.',
    q: 'Is my data — and my clients’ data — secure?',
  },
  {
    a: 'Yes. Planno installs as an app on your phone, works offline during site visits, and syncs photos and notes once the signal comes back.',
    q: 'Does it work on site, on a bad connection?',
  },
]

export const EnFaqSection = () => (
  <section className="bg-white py-28">
    <div className="mx-auto max-w-[820px] px-6">
      <ScrollReveal>
        <h2 className="text-center font-display text-[#0b0b0d] text-[clamp(34px,5vw,50px)] tracking-[-0.01em]">
          Frequently asked questions
        </h2>
      </ScrollReveal>

      <div className="mt-14">
        {EN_FAQS.map((faq) => (
          <ScrollReveal key={faq.q}>
            <div className="border-[#ececec] border-t py-7 last:border-b">
              <h3 className="font-semibold text-[#0b0b0d] text-[clamp(17px,2.2vw,20px)]">
                {faq.q}
              </h3>
              <p className="mt-2.5 max-w-[640px] text-[#8a8a90] text-[clamp(15px,2vw,17px)] leading-relaxed">
                {faq.a}
              </p>
            </div>
          </ScrollReveal>
        ))}
      </div>
    </div>
  </section>
)
